import { ActionTree, MutationTree, GetterTree } from 'vuex';

import { Agent } from '@/models/agent';
import { AgentService } from '@/services/agent-service';

const agentService = new AgentService();

export const state = {
  agents: [] as Agent[]
};

export type AgentState = typeof state;

export const mutations: MutationTree<AgentState> = {
  SET_AGENTS(state: any, payload: Agent[]) {
    state.agents = payload;
  },

  ADD_AGENT(state: any, payload: Agent) {
    state.agents.push(payload);
  },

  UPDATE_AGENT(state: any, payload: Agent) {
    const index = state.agents.findIndex(
      (agent: Agent) => agent.id === payload.id
    );
    state.agents.splice(index, 1, payload);
  },

  REMOVE_AGENT(state: any, payload: number) {
    const index = state.agents.findIndex(
      (agent: Agent) => agent.id === payload
    );
    state.agents.splice(index, 1);
  }
};

export const actions: ActionTree<AgentState, AgentState> = {
  createAgent: async ({ commit }: any, payload: Agent) =>
    agentService
      .createAgent(payload)
      .then((agent: Agent) => commit('ADD_AGENT', agent)),

  fetchAgents: async ({ commit }: any) =>
    agentService.fetchAgents().then((agents: Agent[]) => {
      commit('SET_AGENTS', agents);
    }),

  fetchAgent: async ({ commit }: any, payload: number) =>
    agentService.fetchAgent(payload).then((agent: Agent) => {
      const index = state.agents.findIndex((v: Agent) => v.id === agent.id);
      if (index === -1) {
        commit('ADD_AGENT', agent);
      } else {
        commit('UPDATE_AGENT', agent);
      }
    }),

  updateAgent: async ({ state, commit }: any, payload: Agent) =>
    agentService.updateAgent(payload).then((agent: Agent) => {
      const index = state.agents.findIndex((v: Agent) => v.id === agent.id);
      if (index === -1) {
        commit('ADD_AGENT', agent);
      } else {
        commit('UPDATE_AGENT', agent);
      }
    }),

  deleteAgent: async ({ commit }: any, agentId: number) =>
    agentService.deleteAgent(agentId).then(() => {
      commit('REMOVE_AGENT', agentId);
    })
};

export const getters: GetterTree<AgentState, AgentState> = {
  getAgentById: (state: AgentState) => (id: number) => {
    return state.agents.find(agent => agent.id === id);
  }
};
